export const USER_ACTIONS = {
  SET_STATE: 'user/setState',
  GET_USERS: 'user/getUsers',
  GET_USER_BY_ID: 'user/getUserById',
  CREATE_USER: 'user/createUser',
  UPDATE_USER: 'user/updateUser',
};
